import { ModalRouteProps } from 'context/ModalRouter';
import { useMemo } from 'react';
import { createSearchFromParams, parseQueryParamToNumbers } from 'utils/url';
import dayjs, { Dayjs } from 'dayjs';

export type PostModalQueryParams = {
  id: number | undefined;
  date: Dayjs | undefined;
  text?: string | undefined;
  profileIds: number[];
  compose?: boolean;
};

export type PostModalOnClose = (options?: {
  postIdToOpen?: number;
  isPostCreationDone?: boolean;
  showFirstPostModal?: boolean;
  pageId?: number;
}) => void;

export function usePostModal({ modalManager, modalHistory }: ModalRouteProps) {
  const params = modalManager.getQueryParameters(
    ['id', 'compose', 'date', 'profileIds', 'text'],
    { parse: false },
  );

  const queryParams = useMemo((): PostModalQueryParams => {
    const id = Number(params.id);
    const date = dayjs(params.date);

    return {
      id: Number.isFinite(id) && id > 0 ? id : undefined,
      date: date.isValid() ? date : undefined,
      profileIds: parseQueryParamToNumbers(params.profileIds),
      compose: params.compose === 'true',
      text: params.text ?? undefined,
    };
  }, [params]);

  const onClose: PostModalOnClose = async (params) => {
    if (params?.postIdToOpen) {
      modalHistory.replace({
        search: createSearchFromParams({
          id: params.postIdToOpen,
          isPostCreationDone: params.isPostCreationDone,
        }),
      });
    } else {
      modalManager.close();
    }
  };

  return {
    queryParams,
    onClose,
  };
}
